module.exports = __webpack_public_path__ + "0d91a9a79f097fb0e2358dc17edaecd7.fbx";